<msc-feat-correction-list [corrections]="correction" [title]="contents[index].title" [index]="index" *ngFor="let correction of corrections; let index = index"></msc-feat-correction-list>
